import { useEffect, useState } from 'react';
import DepartmentsList from '../../../Api/definitionSelectDepartment';

const useEmployee = setIsLoading => {
  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    DepartmentsList().then(data => {
      setDepartments(data.departmentsList);
      setIsLoading(false);
    });
  }, []);

  return {
    departments,
    setDepartments,
  };
};

export default useEmployee;
